import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides operations for special days
 */
export class SpecialDayService {
  private resource: InterACT.Interfaces.IResource<InterACT.Interfaces.SpecialDays.SpecialDayResponse | InterACT.Interfaces.SpecialDays.SpecialDaysResponse>;

  constructor($resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.resource = $resource('api/special-days/:dayId', undefined, { update: { method: 'PUT' } });
  }

  /**
   * Function to create a special day
   *
   * @param specialDay An object representation of a special day
   * @returns A promise that resolves when the create operation is completed
   */
  public create(specialDay: InterACT.Interfaces.SpecialDays.SpecialDay) {
    return this.resource.save(specialDay).$promise;
  }

  /**
 * Retrieves a single special day with the supplied id
 * @param id the id of the special day to retrieve
 * @return a promise that resolves with a special day response
 */
  public get(id: string) {
    return <ng.IPromise<InterACT.Interfaces.SpecialDays.SpecialDayResponse>>this.resource.get({ dayId: id }).$promise;
  }

  /**
 * Function to update a special day
 *
 * @param specialDay An object representation of the special day resource to be updated
 * @returns The http promise that resolves once the service interaction is complete
 */
  public update(specialDay: InterACT.Interfaces.SpecialDays.SpecialDay) {
    return (<any>this.resource).update({ dayId: specialDay.id }, specialDay).$promise;
  }

  /**
  * Function to delete a special day
  *
  * @param specialDayId The id of the special day to delete
  * @returns The http promise that resolves once the service interaction is complete
  */
  public delete(specialDayId: string) {
    return this.resource.delete({ dayId: specialDayId }).$promise;
  }

  /**
 * Function to retrieve a list of special days
 *
 * @param page The number of the page of data to be retrieved
 * @param perPageCount The number of items per page to be retrieved
 * @param query the query to execute against the dataset
 * @returns A http promise that resolves with a special days response
 */
  public getList(page: number, perPageCount: number, query?: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, query);
    return <ng.IPromise<InterACT.Interfaces.SpecialDays.SpecialDaysResponse>>this.resource.get(options).$promise;
  }
}
